import wx from 'weixin-js-sdk'
import qs from 'qs'
import service, { YZFYSF_ACT_ID } from '@/config'
// import { getInquireCity } from '@/service/api/product'
import validateIdent from '@/utils/identity'
// import { geolocation } from '@/utils/gaodeMap.js'
import { TERMINAL_MAP, AGE_MAP, ORDER_STATUS_CODE, CHANNEL_ID } from '@/config/codeMap'
import { bridge } from '@/common/bridge/methods'
import { handleBridgeResponse } from '@/common/functions/handleBridgeResponse'
import { BRIDGE_METHODS } from '@/common/bridge/constants'
import { getLegacyUserSession, setLegacyUserInfo, useUserStoreOutside } from '@/pinia/user'
import { NavigateToWebview } from '@/utils/webviewNavigation'
import { bindVip } from '@/service/api/activity'
import { router } from '@/router'
import { isInWeChatMiniProgram } from '@/utils/tool'
const isInWeChat = isInWeChatMiniProgram()
// 数组按指定长度分割
export function arrSizeDivision(array, size) {
  //获取数组的长度，如果你传入的不是数组，那么获取到的就是undefined
  const length = array.length
  //判断不是数组，或者size没有设置，size小于1，就返回空数组
  if (!length || !size || size < 1) {
    return []
  }
  //核心部分
  let index = 0 //用来表示切割元素的范围start
  let resIndex = 0 //用来递增表示输出数组的下标

  //根据length和size算出输出数组的长度，并且创建它。
  let result = new Array(Math.ceil(length / size))
  //进行循环
  while (index < length) {
    //循环过程中设置result[0]和result[1]的值。该值根据array.slice切割得到。
    result[resIndex++] = array.slice(index, (index += size))
  }
  //输出新数组
  return result
}
// 获取数组中有值的参数
export function getValue(value) {
  let arr = Array.isArray(value) ? value : value.split(',')
  return arr.reduce((result, item) => {
    if (!result) {
      result = item
    }
    return result
  }, '')
}
// 获取终端类型
/**
export async function getTerminalType() {
  let terminal = TERMINAL_MAP.normalBrowser // TERMINAL_MAP.normalBrowser
  const search = window.location.search.replace('?', '')
  let { terminal: terminalFromUrl = '' } = qs.parse(search) || {}
  let newTerminal = getValue(terminalFromUrl)
  // 从url获取
  if (newTerminal) {
    terminal = newTerminal
  } else {
    // 从userAgent判断终端
    var agent = navigator.userAgent.toLowerCase()
    // 云闪付小程序
    if (/(com.unionpay.chsp)/.test(agent) || /(com.unionpay.mobilepay)/.test(agent)) {
      terminal = TERMINAL_MAP.cloudQuickPayMini
    } else if (agent.indexOf('micromessenger') != -1) {
      // wx.miniProgram.getEnv比较坑，普通浏览器中不执行回调，这里要先判断下是不是微信环境（公众号/小程序）
      try {
        if (parent.frames.length !== window.frames.length) {
          console.log(2222)
          terminal = TERMINAL_MAP.ctsPay
        } else {
          if (await wechatMiniGetEnv()) {
            terminal = TERMINAL_MAP.wechatMini
          }
        }
      } catch (error) {
        console.error('wx.miniProgram.getEnv error', error)
      }
    } else if (agent.indexOf('bestpay') > -1) {
      // 翼支付
      terminal = TERMINAL_MAP.bestPay
    } else if (agent.indexOf('toutiaomicroapp') > -1) {
      // 抖音 字节跳动小程序
      terminal = TERMINAL_MAP.tiktok
    }
  }
  console.log('finnal terminal-------->>>>>>>>>>', terminal)
  return terminal
}
 */

// 获取使用的jssdk类型 如 微信sdk、字节sdk
export function getSdkFn() {
  var agent = navigator.userAgent.toLowerCase()
  if (agent.indexOf('toutiaomicroapp') > -1) {
    return window.tt
  } else {
    const terminal = sessionStorage.getItem('terminal')
    // 浏览器环境重写miniProgram路由方法
    if (terminal === TERMINAL_MAP.ctsPay) {
      const apiList = ['navigateTo', 'redirectTo', 'switchTab']
      apiList.forEach(key => {
        wx.miniProgram[key] = params => {
          console.log('params', params)
          window.top.postMessage(
            {
              router: {
                type: key,
                params,
              },
            },
            '*'
          )
        }
      })
    }
    return wx
  }
}
// 判断是否是微信小程序环境
async function wechatMiniGetEnv() {
  return new Promise(resolve => {
    wx.miniProgram.getEnv(res => {
      if (res.miniprogram) {
        resolve(true)
      } else {
        resolve(false)
      }
    })
  })
}
// 跳转梁硕公共方法,添加公共参数，environment应用类型，urlTerminal老的terminal参数，mobile手机号,loginId,loginToken
export async function linkToB2c(url) {
  if (!url) return
  // 微信小程序新开webview
  if (sessionStorage.getItem('terminal') === TERMINAL_MAP.wechatMini) {
    return getSdkFn()?.miniProgram?.navigateTo({
      url: `/pages/webview/index?url=${encodeURIComponent(url)}`,
    })
  }
  // 其他环境手动拼接b2c需要的参数后使用location跳转
  const storeUserInfo = useUserStoreOutside().userInfo
  const storedSessionUserInfo = getObjTypeStorage('userInfo', true) || {}
  const legacyUserInfo = getLegacyUserSession()
  const userInfo = storeUserInfo?.loginToken
    ? storeUserInfo
    : legacyUserInfo.loginToken
      ? legacyUserInfo
      : storedSessionUserInfo
  const params = {
    ...userInfo,
    environment: sessionStorage.getItem('environment'),
    sourceflag: sessionStorage.getItem('sourceFlag'),
  }
  console.log('params', params)
  const urlTerminal = sessionStorage.getItem('urlTerminal')
  if (urlTerminal) {
    params[urlTerminal] = '1'
  }
  let publicParamsStr = querySerialize(params)
  if (url.indexOf('?') == -1) {
    url = `${url}?${publicParamsStr}`
  } else {
    url = `${url}&${publicParamsStr}`
  }
  // 动态检测是否在小程序环境中
  const isInMiniProgram = isInWeChatMiniProgram()
  console.log('isInMiniProgram:', isInMiniProgram)
  if (isInMiniProgram) {
    console.log('url000000', window.location.href)
    // 在小程序环境中修改URL参数
    console.log('url111111', url)
    const [baseUrl, queryString] = url.split('?')
    const urlParams = new URLSearchParams(queryString)
    urlParams.set('environment', '2')
    urlParams.set('isZllx', '1')
    const loginId = sessionStorage.getItem('loginId') || ''
    const loginToken = sessionStorage.getItem('loginToken') || ''
    const memberId = sessionStorage.getItem('memberId') || ''
    const mobile = sessionStorage.getItem('mobile') || ''
    const code = sessionStorage.getItem('code') || ''
    if (loginId) {
      urlParams.set('loginId', loginId)
    }
    if (loginToken) {
      urlParams.set('loginToken', loginToken)
    }
    if (memberId) {
      urlParams.set('memberId', memberId)
    }
    if (mobile) {
      urlParams.set('mobile', mobile)
    }
    if (code) {
      urlParams.set('code', code)
    }
    url = `${baseUrl}?${urlParams.toString()}`
    console.log('url222222', url)

    // 小程序内跳外部链接之前吧登录信息存ls内，下次进来取ls给ss赋值后清空ls
    localStorage.setItem('loginId', loginId)
    localStorage.setItem('loginToken', loginToken)
    localStorage.setItem('memberId', memberId)
    localStorage.setItem('mobile', mobile)
    localStorage.setItem('code', code)
  }
  window.location.href = url
}
// 中旅通支付相关页面跳转
export async function linkToCtsPay(params) {
  getSdkFn()?.miniProgram?.navigateTo({
    url: `/pages/payPage/index?${qs.stringify(params)}`,
  })
}
// 跳转首页
export async function linkToIndex() {
  if (isInWeChat) {
    getSdkFn()?.miniProgram?.switchTab({
      url: `/pages/index/index`,
    })
    return
  }
  bridge.invokeSync(BRIDGE_METHODS.GO_HOME)
}
// 对象序列化成query,示例：{name:"zhangsan",age:20} => name=zhangsan&age=20
export const querySerialize = obj =>
  Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')
// 获取对象格式的sessionStorage,,isSessionStorage是否存sessionStorage
export const getObjTypeStorage = (key, isSessionStorage) => {
  const api = window[isSessionStorage ? 'sessionStorage' : 'localStorage']
  let data = decodeURIComponent(api.getItem(key) || '')
  try {
    if (data) {
      data = JSON.parse(data)
    }
  } catch (error) {
    data = ''
    console.log('getObjTypeStorage', error)
  }
  return data
}
// 设置对象格式的sessionStorage，必须encodeURIComponent，否则JSON.parse的时候会报错,isSessionStorage是否存sessionStorage
export const setObjTypeStorage = (key, value = undefined, isSessionStorage = false) => {
  const api = window[isSessionStorage ? 'sessionStorage' : 'localStorage']
  api.setItem(key, encodeURIComponent(JSON.stringify(value)))
}
export const getCity = async () => {
  let { cityId, cityName, isAbroad } = getCityFromSessionStorage()
  // 0.中旅旅行h5传过来的城市，例：北京市
  if (cityName && !cityId) {
    const { cityId: cid, isAbroad: isA } = await getCityIdByName(cityName)
    cityId = cid
    isAbroad = isA
  }
  // 1.使用高德定位获取城市
  // if (!cityName || !cityId) {
  //   cityName = await getLocation()
  //   if (cityName) {
  //     cityName = cityName.replace('市', '')
  //     const { cityId: cid, isAbroad: isA } = await getCityIdByName(cityName)
  //     cityId = cid
  //     isAbroad = isA
  //   }
  // }
  // 2.以上都没有获取成功则使用默认城市北京
  if (!cityName || !cityId) {
    cityName = '北京'
    cityId = 1
    isAbroad = 0
  }
  sessionStorage.setItem('cityId', cityId)
  sessionStorage.setItem('cityName', cityName)
  sessionStorage.setItem('isAbroad', isAbroad)
  // 下面这句为当前版本兼容写法，以后删除
  sessionStorage.setItem('localCity', cityName)
  return {
    cityName,
    cityId,
    isAbroad,
  }
}
// 从session获取城市
export const getCityFromSessionStorage = () => {
  let cityId = sessionStorage.getItem('cityId')
  let cityName = sessionStorage.getItem('cityName')
  let isAbroad = +sessionStorage.getItem('isAbroad')
  if (cityId === 'undefined' || cityId === 'null') {
    cityId = ''
  }
  if (cityName === 'undefined' || cityName === 'null') {
    cityName = ''
  }
  return {
    cityId,
    cityName,
    isAbroad,
  }
}
// 根据城市名称获取城市id
export const getCityIdByName = async cityName => {
  let res = null
  try {
    const cityCnName = Array.isArray(cityName) ? '北京' : cityName
    // res = (await getInquireCity({ cityCnName })) || {}
    res = {}
    if (res?.records[0]) {
      const { cityId, isAbroad } = res?.records[0]
      return { cityId, isAbroad }
    }
  } catch (error) {
    console.error('getInquireCity error', error)
  }
  return {}
}
// 获取定位，输出城市名称，例 南京市
export const getLocation = async () => {
  let res = null
  try {
    // res = (await geolocation()) || {}
  } catch (error) {
    console.error('getLocation error', error)
  }
  const { addressComponent } = res
  if (addressComponent) {
    return addressComponent.city || addressComponent.province
  }
  return null
}
// 移除url的登录,环境等公共参数，因为登陆后原生会重新拼接上去信息,isOnleyRemoveLoginInfo是否只移除登录信息,保留env等环境参数,否则移除所有公共参数
export const removePubParamsOfUrl = (url = '', isOnleyRemoveLoginInfo) => {
  const splitArr = url.split('?')
  if (splitArr.length < 2) {
    return url
  }
  let restParams = {}
  if (isOnleyRemoveLoginInfo) {
    // eslint-disable-next-line
    const { loginId, loginToken, memberId, mobile, ...rParams } = getAllQueryString(url) || {}
    restParams = rParams
  } else {
    /* eslint-disable */
    const {
      city,
      cityId,
      isAbroad,
      environment,
      env,
      loginId,
      loginToken,
      memberId,
      mobile,
      sourceflag,
      sourceFlag,
      code,
      terminal,
      ...rParams
    } = getAllQueryString(url) || {}
    /* eslint-enable */
    restParams = rParams
  }
  return `${splitArr[0]}?${querySerialize(restParams)}`
}
/**
 * 跳转登录页
 * @param {Function} onLoginSuccess - 登录成功回调（非微信小程序环境使用）
 * @param {boolean} hasHistory - 是否有历史记录，决定使用 navigateTo 还是 redirectTo
 * @param {Object} options - 可选配置
 * @param {string} options.targetUrl - 登录成功后跳转的目标页面 URL（微信小程序环境使用）
 */
export const toLogin = async (onLoginSuccess, hasHistory = true, options = {}) => {
  const { targetUrl } = options

  try {
    if (isInWeChat) {
      // 微信小程序环境去原生登录页登录
      // 如果指定了 targetUrl，登录成功后跳转到目标页面；否则返回当前页面
      const redirectUrl = targetUrl
        ? `${window.location.origin}/#/${targetUrl.replace(/^\//, '')}`
        : removePubParamsOfUrl(location.href)
      getSdkFn()?.miniProgram?.[hasHistory ? 'navigateTo' : 'redirectTo']({
        url: `/pages/login/index?url=${encodeURIComponent(redirectUrl)}`,
      })
      return
    }
    // 其他环境调用原生登录
    const res = await bridge.invokeSync(BRIDGE_METHODS.LOGIN)
    if (res && res.result && res.result.code === 0 && res.result.data) {
      // 登录成功后重新获取用户信息
      handleBridgeResponse(res, setLegacyUserInfo, '登录')
      if (onLoginSuccess) {
        onLoginSuccess()
      } else {
        // 刷新当前页面以更新状态
        window.location.reload()
      }
    }
  } catch (error) {
    console.error('登录失败:', error)
  }
}
// 获取所有的路径参数
export const getAllQueryString = url => {
  // str为？之后的参数部分字符串
  const str = url.substr(url.indexOf('?') + 1)
  // arr每个元素都是完整的参数键值
  const arr = str.split('&')
  // result为存储参数键值的集合
  const result = {}
  for (let i = 0; i < arr.length; i++) {
    // item的两个元素分别为参数名和参数值
    const item = arr[i].split('=')
    result[item[0]] = item[1]
  }
  return result
}
// 只替换路径段，避免误改 jync-public-read 这类 bucket 域名。
const replacePublicPathSegment = url => {
  const splitIndex = url.search(/[?#]/)
  const pathPart = splitIndex === -1 ? url : url.slice(0, splitIndex)
  const suffix = splitIndex === -1 ? '' : url.slice(splitIndex)

  return pathPart.replace(/(^|\/)public(?=\/|$)/, '$1thumb') + suffix
}

// 替换产品图路径中的public
export const replaceProductImg = url => {
  if (!url) {
    return ''
  }
  return import.meta.env.VITE_APP_ENV !== 'production' ? url : replacePublicPathSegment(url)
}
// 判断当前环境是ios还是android
export const getPlantFormType = () => {
  let u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('android') > -1
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("ios") > -1
  if (isAndroid) {
    return 'android'
  } else if (isiOS) {
    return 'ios'
  }
  return ''
}

/**
 * 判断app环境提供给h5使用 - 本机调试环境
 * 1. 安卓环境：ctg-zllx-android
 * 2. iOS环境：ctg-zllx-ios
 * @returns {string} 'android' | 'ios' | ''
 */
export const getAppEnv = () => {
  const ua = navigator.userAgent
  const isAndroid = ua === 'ctg-zllx-android'
  const isiOS = ua === 'ctg-zllx-ios'
  return isAndroid ? 'isAndroid' : isiOS ? 'isIos' : ''
}

// 动态加载js
export function dynamicLoadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = function () {
      resolve(src)
    }
    script.onerror = function () {
      reject(new Error('Failed to load ' + src), script)
    }
    document.body.appendChild(script)
  })
}
// 动态加载多条js
export function loadScripts(urls) {
  return Promise.all(urls.map(url => dynamicLoadScript(url)))
}
/**
 * 复制文本到剪贴板
 * @param {string|number} text - 要复制的文本内容
 * @returns {Promise<boolean>} - 复制是否成功
 */
export async function triggerCopy(text) {
  if (!text && text !== 0) return false
  // 判断是否为 Flutter 环境
  const isFlutter =
    window.flutter_inappwebview || window.webkit?.messageHandlers?.flutter_inappwebview

  // Flutter 环境：使用 bridge 方法
  if (isFlutter) {
    try {
      const res = await bridge.invokeSync(BRIDGE_METHODS.COPY_TRIP, String(text))
      return !!res
    } catch (e) {
      return false
    }
  }

  // 非 Flutter 环境：使用现代原生复制方法
  const copyToClipboard = text => {
    const isSafari = navigator.userAgent.match(/iPad|iPhone|iPod|Macintosh/i)
    return new Promise(resolve => {
      if (navigator.clipboard && isSafari) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            resolve(true)
          })
          .catch(() => {
            resolve(false)
          })
      } else {
        import('copy-to-clipboard').then(({ default: copy }) => {
          resolve(
            copy(text, {
              format: 'text/plain',
              message: '请点击确定按钮复制链接',
            })
          )
        })
      }
    })
  }

  try {
    // 非 Flutter 环境使用原生复制方法
    return await copyToClipboard(String(text))
  } catch (_) {
    return false
  }
}
// 复制功能
export async function clipboard(text) {
  let copySuccess = true
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    // clipboard api 复制
    try {
      await navigator.clipboard.writeText(text)
    } catch (error) {
      console.error('writeText', error)
      copySuccess = false
    }
  } else {
    var textarea = document.createElement('textarea')
    document.body.appendChild(textarea)
    // 隐藏此输入框
    textarea.style.position = 'fixed'
    textarea.style.clip = 'rect(0 0 0 0)'
    textarea.style.top = '10px'
    // 赋值
    textarea.value = text
    // 选中
    textarea.select()
    // 复制
    copySuccess = document.execCommand('copy', true)
    // 移除输入框
    document.body.removeChild(textarea)
  }
  return copySuccess
}
// 深度克隆数组或者对象
export const deepClone = o => {
  if (o instanceof Array) {
    let n = []
    for (let i = 0; i < o.length; ++i) {
      n[i] = deepClone(o[i])
    }
    return n
  } else if (o instanceof Object) {
    let n = {}
    for (let i in o) {
      n[i] = deepClone(o[i])
    }
    return n
  } else {
    return o
  }
}
// 获取年龄
export const getAgeByBrithday = strBirthday => {
  let returnAge
  let strBirthdayArr = strBirthday.split('-')
  let birthYear = strBirthdayArr[0]
  let birthMonth = strBirthdayArr[1]
  let birthDay = strBirthdayArr[2]

  const d = new Date()
  let nowYear = d.getFullYear()
  let nowMonth = d.getMonth() + 1
  let nowDay = d.getDate()

  if (nowYear == birthYear) {
    returnAge = 0 //同年 则为0岁
  } else {
    let ageDiff = nowYear - birthYear //年之差
    if (ageDiff > 0) {
      if (nowMonth == birthMonth) {
        let dayDiff = nowDay - birthDay //日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      } else {
        let monthDiff = nowMonth - birthMonth //月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      }
    } else {
      returnAge = -1 //返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return returnAge //返回周岁年龄
}
// 获取年龄,性别,出生日期
export const getPeopleInfoFromCertNo = certNo => {
  if (!validateIdent.IdentityCodeValid(certNo)) {
    return
  }
  let len = certNo.length
  let birthday, age, sex
  if (len == '15') {
    let re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
    let arr_data = certNo.match(re_fifteen) // 正则取号码内所含出年月日数据
    let year = arr_data[2]
    let month = arr_data[3]
    let day = arr_data[4]
    birthday = `${year}-${month}-${day}`
  }
  //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
  if (len == '18') {
    let re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/
    let arr_data = certNo.match(re_eighteen) // 正则取号码内所含出年月日数据
    let year = arr_data[2]
    let month = arr_data[3]
    let day = arr_data[4]
    birthday = `${year}-${month}-${day}`
  }

  let iCard = validateIdent.IdentityCode_changeFivteenToEighteen(certNo)
  if (parseInt(iCard.charAt(16)) % 2 == 0) {
    sex = '1' // 女生
  } else {
    sex = '0' // 男生
  }
  age = getAgeByBrithday(birthday)
  return {
    birthday,
    sex,
    age,
  }
}
// 获取人员信息是成人或者儿童
export const getAgeType = age => {
  if (age || age === 0) {
    if (age < 2) {
      return AGE_MAP.baby
    }
    if (age >= 2 && age < 12) {
      return AGE_MAP.child
    }
    return AGE_MAP.adult
  }
  return ''
}
// 过滤掉字符串中的表情包
export const formatterContacterName = (value = '') => {
  // return value.replace(/[^a-z\u4e00-\u9fbb\/]/g, '')
  return unescape(escape(value).replace(/\%uD.{3}/g, ''))
}
// 非数字过滤
export const formatterNumber = (value = '') => {
  return value.replace(/[^0-9]/g, '')
}
// 小程序api转promise
export const promisify = api => {
  return (options, ...params) => {
    return new Promise((resolve, reject) => {
      api(Object.assign({}, options, { success: resolve, fail: reject }), ...params)
    })
  }
}
// 判断数组son是否是数组father的子集，仅针对数组项是简单数据类型，true表示不是子集
export const arrayContain = (father = [], son = []) => !son.some(item => !father.includes(item))
// 打开地图
export const openMap = (router, query) => {
  // 普通浏览器使用h5地图
  if (sessionStorage.getItem('terminal') === TERMINAL_MAP.ctsPay) {
    return router.push({
      path: '/map',
      query,
    })
  }
  // 微信小程序环境使用微信自带地图
  getSdkFn()?.miniProgram?.navigateTo({
    url: `/hotelModule/pages/openLocation/index?${querySerialize(query)}`,
  })
}
// 更新页头和导航栏的标题
/**
 * Updates the page title and synchronizes it with the router's meta title.
 * Also sends the updated title to the parent window via postMessage.
 *
 * @param {Object} router - Vue router instance
 * @param {string} title - New title to set
 */
export const updateTitle = (router, title) => {
  document.title = title
  window.top.postMessage({ title: title }, '*')
  const currentRoute = router.currentRoute
  const meta = currentRoute.value.meta
  currentRoute.value = {
    ...currentRoute.value,
    meta: {
      ...meta,
      title: title || meta.title,
    },
  }
}
// 给localstorage赋值，便于原生转译的h5使用
export const setStorageSync = (key, value) => {
  // 对象转换成字符串
  if (value instanceof Object) {
    value = JSON.stringify(value)
  }
  localStorage.setItem(key, `{"data":${value}}`)
}
// 订单按钮的显示判断
export const orderActionCode = (item, type) => {
  const { actionCode, orderCustomerStatus } = item //订单开关状态和订单描述状态
  const signActionList = ['100', '110', '111', '101'] //倒数第三位是1
  const payActionList = ['010', '110', '111', '011'] //倒数第二位是1
  const cancelActionList = ['001', '101', '111', '011'] //倒数第一位是1
  const confirmActionList = ['10000', '10001', '11111', '10011', '10111'] //倒数第五位是1
  const terminal = sessionStorage.getItem('terminal')
  // 签约按钮第三位是1
  if (type === 'sign') {
    // 截取状态码后三位
    const CODE = actionCode.substring(5)
    return signActionList.includes(CODE) ? true : false
  }
  // 支付按钮第二位是1
  if (type === 'pay') {
    // 截取状态码后三位
    const CODE = actionCode.substring(5)
    // 抖音支付按钮开关
    const tiktokPay =
      terminal === TERMINAL_MAP.tiktok && orderCustomerStatus === ORDER_STATUS_CODE.awaitPay
    const payBtn = payActionList.includes(CODE)
    return payBtn || tiktokPay ? true : false
  }
  // 申请取消按钮第一位是1
  if (type === 'cancel') {
    // 截取状态码后三位
    const CODE = actionCode.substring(5)
    return cancelActionList.includes(CODE) ? true : false
  }
  // 确认取消按钮第五位是1
  if (type === 'confirmCancel') {
    // 截取状态码后五位
    const CODE = actionCode.substring(3)
    return confirmActionList.includes(CODE) ? true : false
  }
}
export const saleCountFormat = value => {
  let returnValue = ''
  if (value < 100) {
    returnValue = value + ''
  }
  if (value <= 999 && value >= 100) {
    returnValue = Math.floor(value / 100) + '00+'
  }
  if (value <= 9999 && value >= 1000) {
    returnValue = Math.floor(value / 1000) + '000+'
  }
  if (value >= 10000) {
    returnValue = Math.floor(value / 10000) + '万+'
  }
  return returnValue
}
/**
 * 酒店  签证 认证  不展示
 * @param firstProductClassId
 */
export const isShowSaleCount = firstProductClassId => {
  if ([CHANNEL_ID?.hotel, CHANNEL_ID?.visa, CHANNEL_ID?.cert].includes(firstProductClassId)) {
    return false
  }
  return true
}
// 参考价 取成人价
export const finalPrice = item => {
  if (item.firstProductClassId === 9) {
    //门券产品取最低起价
    return item.lowestPrice
  } else if (item.adultReferencePrice) {
    return item.adultReferencePrice
  } else {
    return ''
  }
}
// 获取景点主图
export const scenicPic = picList => {
  if (picList?.length > 0) {
    // 2为头图
    const pics = picList.filter(item => item.pictureType == 1)
    if (pics.length > 0) {
      return pics[0].url
    } else {
      return picList[0].url
    }
  } else {
    return ''
  }
}

/**
 * @description: 判断浏览器环境， miniProgram 微信小程序环境 ； wxWeb 微信浏览器环境； others 其他浏览器
 * @param {*}
 * @return {promise}
 * @author:
 */
export const getBrowserEnv = () => {
  return new Promise(resolve => {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //微信环境下
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          // 小程序环境下逻辑
          resolve('miniProgram')
        } else {
          //非小程序环境下逻辑
          resolve('wxWeb')
        }
      })
    } else {
      resolve('others')
    }
  })
}

export const picFormat = pic => {
  return pic
    ? import.meta.env.VITE_APP_ENV === 'sst'
      ? pic
      : replacePublicPathSegment(pic.replace(/^http:/i, 'https:'))
    : defaultImg
}

/**
 * px转vw
 * @param {number} px
 * @returns {string} vw值
 */
export const px2vw = px => {
  return (px / 375) * 100 + 'vw'
}

// 根据url判断打开方式
export const goPage = async (item, iconName) => {
  if (item.linkUrl) {
    const vipArr = [
      '/flight/index',
      '/train/index',
      '/hotel/index',
      '/car/index',
      '/ticket/index',
      '/buffet/index',
      '/intlFlight/index',
      '/intlHotel/index',
    ]
    if (vipArr.includes(item.linkUrl) || item.linkUrl.startsWith('/tour')) {
      const res = await bindVip({
        customerHashCode: import.meta.env.VITE_VIP_CUSTOMER_HASH_CODE,
      })
      const { accessToken: token, terminalCode, channelNoStr } = res.data ?? {}
      if (!token) return
      // zlWeapp
      await toLogin()
      const code = sessionStorage.getItem('code') || ''
      const splice = item.linkUrl.indexOf('?') != -1 ? '&' : '?'
      const fullUrl = `${import.meta.env.VITE_VIP_URL}${item.linkUrl}${splice}channel=zlWeapp&token=${token}&code=${code}&terminalCode=${terminalCode}&channelCode=${channelNoStr}`
      NavigateToWebview({ fullUrl, title: item.iconName || '产品详情' })
    } else {
      const linkUrlArr = item.linkUrl.split(',')
      if (item.linkUrl.indexOf('appId') !== -1 && linkUrlArr.length > 1) {
        const appId = linkUrlArr[0].replace('appId:', '')
        const path = linkUrlArr[1].replace('path:', '')
        console.log(linkUrlArr, appId, path)
        NavigateToWebview({ fullUrl: `${window.location.origin}/#/${path}`, title: '产品详情' })
      } else if (item.linkUrl.indexOf('http') !== -1) {
        // 中旅通特殊处理
        NavigateToWebview({ fullUrl: item.linkUrl, title: '产品详情' })
      } else {
        const detailUrl = iconName
          ? item.linkUrl.indexOf('?') > -1
            ? `${item.linkUrl}&title=${item.iconName}`
            : `${item.linkUrl}?title=${item.iconName}`
          : item.linkUrl
        NavigateToWebview({ projectName: 'client', title: '产品详情', url: detailUrl })
      }
    }
  }
}

// 将 http: 开头的图片地址转换为 https:
export const getImageUrl = url => {
  if (!url) return url
  if (typeof url === 'string' && url.startsWith('http:')) {
    return url.replace('http:', 'https:')
  }
  return url
}
